import AdminCrud from "@/components/admin/AdminCrud";

export default function AdminGallery() {
  return (
    <AdminCrud
      title="Gallery"
      resource="gallery"
      defaultItem={{ title: "", category: "", image_url: "", order: 1 }}
      fields={[
        { key: "title", label: "Title" },
        { key: "category", label: "Category (Album)" },
        { key: "image_url", label: "Image", type: "image" },
        { key: "order", label: "Order", type: "number" },
      ]}
    />
  );
}
